// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  position: relative;
  width: 100%;
  height: 100%;
}

.image {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.image.sm {
  width: 50px;
  height: 50px;
}
.image.md {
  width: 80px;
  height: 80px;
}
.image.lg {
  width: 110px;
  height: 110px;
}
.image.elg {
  width: 150px;
  height: 150px;
}

img {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/common/components/inline-loader/inline-loader.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACF;;AAIE;EACE,WAAA;EACA,YAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,YAAA;EACA,aAAA;AAHJ;AAME;EACE,YAAA;EACA,aAAA;AAJJ;;AASA;EACE,WAAA;AANF","sourcesContent":[":root {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.image {\r\n  width: 50px;\r\n  height: 50px;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.image {\r\n\r\n  &.sm {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n\r\n  &.md {\r\n    width: 80px;\r\n    height: 80px;\r\n  }\r\n\r\n  &.lg {\r\n    width: 110px;\r\n    height: 110px;\r\n  }\r\n\r\n  &.elg {\r\n    width: 150px;\r\n    height: 150px;\r\n  }\r\n\r\n}\r\n\r\nimg {\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
